import React, { memo, ReactNode } from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import {
  CircleCheckSolidIcon,
  CircleXmarkSolidIcon
} from '../../shared/icons/icons';

import styles from './product-availability-message.one-dt.scss';

interface ProductAvailabilityMessageProps {
  availabilityMessage: string;
  availabilityMessageRank?: number;
  className?: string;
  hideIcons?: boolean;
  hideSuffix?: boolean;
  iconAvailable?: ReactNode;
}

function ProductAvailabilityMessage(props: ProductAvailabilityMessageProps) {
  const {
    availabilityMessage,
    availabilityMessageRank,
    className,
    hideIcons = false,
    hideSuffix = false,
    iconAvailable
  } = props;

  return (
    <Typography
      className={cn(
        styles['container'],
        `${className || ''} product-availability-message`
      )}
      data-testid="product-availability-message"
      tag="span"
    >
      {!hideIcons && (
        <>
          {Number(availabilityMessageRank) > 5 ? (
            <CircleXmarkSolidIcon
              className={cn(
                styles['icon-unavailable'],
                'product-availability-message__icon'
              )}
            />
          ) : (
            <>
              {iconAvailable ? (
                iconAvailable
              ) : (
                <CircleCheckSolidIcon
                  className={cn(
                    styles['icon'],
                    'product-availability-message__icon'
                  )}
                />
              )}
            </>
          )}
        </>
      )}
      <span>
        {availabilityMessage?.replace(' at My Store', '')}
        {!hideSuffix ? ' at ' : ''}
      </span>
    </Typography>
  );
}

export default memo(ProductAvailabilityMessage);
